import FormBody from "../../../../components/form-body";
import Input from "../../../../components/input";
import Label from "../../../../components/label";

export default function GreetingMembershipSkeleton() {
  return (
    <div className="max-w-3xl space-y-6 py-8 text-left">
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            name="name"
            type="text"
            className="animate-pulse bg-gray-100"
            disabled
          />
        </div>

        <div className="mb-4">
          <Label htmlFor="description">Description</Label>
          <div className="h-20 w-full animate-pulse rounded bg-gray-100"></div>
        </div>

        <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-3">
          <div>
            <Label htmlFor="price">Price (Cloods)</Label>
            <Input
              id="price"
              name="price"
              type="number"
              className="animate-pulse bg-gray-100"
              disabled
            />
          </div>
          <div>
            <Label htmlFor="duration">Duration</Label>
            <Input
              id="duration"
              name="duration"
              type="number"
              className="animate-pulse bg-gray-100"
              disabled
            />
          </div>
          <div>
            <Label htmlFor="eGreets">EGreets</Label>
            <Input
              id="eGreets"
              name="eGreets"
              type="number"
              className="animate-pulse bg-gray-100"
              disabled
            />
          </div>
        </div>
      </FormBody>

      <div className="mt-6 flex justify-end gap-4">
        <div className="h-10 w-24 animate-pulse rounded-lg bg-gray-100"></div>
        <div className="h-10 w-32 animate-pulse rounded-lg bg-gray-100"></div>
      </div>
    </div>
  );
}
